import { render } from "./data-table.vue?vue&type=template&id=3eae7d98&ts=true"
import script from "./data-table.vue?vue&type=script&lang=ts"
export * from "./data-table.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__